import React, { createContext, useContext, useState } from 'react';
import { getMaxDateInSearchFilter, getMinDateInSearchFilter } from 'utils/Date';
import { DateOutputStr } from 'utils/DateOutput';

import {
  TableSearchProtocolContextProviderProps,
  TableSearchProtocolContextType
} from './interface';

const TableSearchProtocolContext = createContext({} as TableSearchProtocolContextType);

export function TableSearchProtocolContextProvider({ children }: TableSearchProtocolContextProviderProps) {

  const dateMin = getMinDateInSearchFilter();
  const dateMax = getMaxDateInSearchFilter();

  const [searchNumberProtocol, setSearchNumberProtocol] = useState<string>("");

  const [newData, setNewData] = useState("");
  const [period, setPeriod] = useState({
    from: dateMin ? DateOutputStr(dateMin.toISOString(), 'yyyy-MM-dd') : '',
    to: dateMax ? DateOutputStr(dateMax.toISOString(), 'yyyy-MM-dd') : '',
  });

  const [categorySelected, setCategorySelected] = useState("");
  const [reasonsSelected, setReasonsSelected] = useState('');

  const [searchStr, setSearchStr] = useState("");
  const [profilesFilter, setProfilesFilter] = useState<string[]>([]);

  const [brandsSelected, setBrandsSelected] = useState<string[]>([]);
  const [busFilter, setBUsFilter] = useState<string[]>([]);
  const [subsidiariesSelected, setSubsidiariesSelected] = useState<string[]>([]);
  const [selectedPhase, setSelectedPhase] = useState<string[]>([]);

  const [advancedFilters, setAdvancedFilters] = useState(false);

  const addNumberProtocol = (search: string) => {
    setSearchNumberProtocol(search);
  };

  const addCategorySelected = (category: string) => {
    setCategorySelected(category);
  };

  const addReasonsSelected = (reason: string) => {
    setReasonsSelected(reason);
  };

  const addDescription = (reason: string) => {
    setSearchStr(reason);
  };

  const addResponsibleGroup = (reason: string[]) => {
    setProfilesFilter(reason);
  };

  const addBrands = (reason: string[]) => {
    setBrandsSelected(reason);
  };

  const addBUs = (reason: string[]) => {
    setBUsFilter(reason);
  };

  const addSubsidiaries = (subsidiary: string[]) => {
    setSubsidiariesSelected(subsidiary);
  };

  const addStatusProtocol = (status: string[]) => {
    setSelectedPhase(status);
  };

  const showAdvancedFilter = (isActive: boolean) => {
    setAdvancedFilters(isActive);
  };

  return (
    <TableSearchProtocolContext.Provider
      value={{

        addNumberProtocol: (search) => addNumberProtocol(search),
        searchNumberProtocol: searchNumberProtocol,

        setNewData: (value) => setNewData(value),
        newData: newData,

        setPeriod: (value: any) => setPeriod(value),
        period: period,

        addCategorySelected: (value) => addCategorySelected(value),
        categorySelected: categorySelected,

        addReasonsSelected: (value) => addReasonsSelected(value),
        reasonsSelected: reasonsSelected,

        addDescription: (value) => addDescription(value),
        searchStr: searchStr,

        addResponsibleGroup: (value) => addResponsibleGroup(value),
        profilesFilter: profilesFilter,

        addBrands: (value) => addBrands(value),
        brandsSelected: brandsSelected,

        addBUs: (value) => addBUs(value),
        busFilter: busFilter,

        addSubsidiaries: (value) => addSubsidiaries(value),
        subsidiariesSelected: subsidiariesSelected,

        addStatusProtocol: (value) => addStatusProtocol(value),
        selectedPhase: selectedPhase,

        showAdvancedFilter: (value) => showAdvancedFilter(value),
        advancedFilters: advancedFilters
      }}
    >
      {children}
    </TableSearchProtocolContext.Provider>
  );
}

export const useTableSearchProtocolContext = () => {
  return useContext(TableSearchProtocolContext);
};